<template>
    <div>
        <div class="box">
            <div class="text-box">
                <p class="first-text">Ai uitat parola?</p>
                <p>
                    Introdu adresa de email cu care ti-ai facut cont si iti vom trimite un link de
                    resetare pe email. Te rog sa verifici sectiunea inbox sau spam.
                </p>
            </div>
            <div>
                <validation-observer ref="forgot_password" #default="{ invalid }">
                    <b-form @submit.prevent="send()">
                        <b-form-group
                            id="email-group"
                            label="Email"
                            label-for="email"
                            class="w-100"
                        >
                            <validation-provider
                                #default="{ errors }"
                                rules="required|email"
                                name="email"
                            >
                                <b-form-input
                                    id="email"
                                    v-model="email"
                                    type="email"
                                    placeholder="john@email.com"
                                    class="w-100"
                                >
                                </b-form-input>
                                <small class="text-danger">{{ errors[0] }}</small>
                            </validation-provider>
                            <span
                                v-if="errors.has('email')"
                                class="error-message"
                                v-text="errors.get('email')"
                            ></span>
                        </b-form-group>
                        <div class="w-100">
                            <b-button
                                type="submit"
                                variant="primary"
                                block
                                :disabled="invalid"
                            >Trimite linkul de resetare
                            </b-button>
                        </div>
                    </b-form>
                </validation-observer>
                <div class="logare">
                    <p class="logare">
                        <router-link class="text-blue" :to="'/login'+utmParam"> &lt; Logare </router-link>
                    </p>
                </div>
            </div>
        </div>
        <div class="logo-mic">
            <img alt="LogoSmisMicLogin" src="@/assets/images/LogoSmisMicLogin.png" >
        </div>
    </div>
</template>

<script>
    import { BForm,BFormGroup,BFormInput,BButton} from 'bootstrap-vue';
    // import ButtonGradient from "../../../common/components/ButtonGradient";
    import api from '@/helpers/api';
    import axios from '@/helpers/axios';
    import Errors from '@/helpers/Errors';
    import { startSession } from '@/helpers/auth';
    import { ValidationProvider, ValidationObserver } from 'vee-validate';
    require('@/helpers/validations/validations');

    export default {
        name: "Test",
        components: {
            // ButtonGradient,
            BForm,
            BFormGroup,
            BFormInput,
            BButton,
            ValidationProvider,
            ValidationObserver,
        },

        data() {
            return {
                email: "",
                errors: new Errors(),
                utmParam: null
            };
        },
        created() {
            this.utmParam = this.$route.query && this.$route.query.utm_source ? '?utm_source=' + this.$route.query.utm_source : '';
        },
        methods: {
            send() {
                this.$store.dispatch('auth/logout').then(() => {
                    startSession().then(() => {
                        this.errors.reset();
                        let config = {
                            headers: {
                                'form-origin': 'm3'
                            }
                        }
                        axios.post(api.API_ENDPOINTS.updateUserLocation, { email: this.email, location: 'm3' }).then(() => {
                            axios.post(api.API_ENDPOINTS.forgotPassword, { email: this.email }, config)
                                .then(response => {
                                    this.email = "";
                                    this.$toast.success(response.data.message);
                                    this.$nextTick().then(()=>{
                                        this.$refs.forgot_password.reset();
                                    })

                                })
                                .catch(xhr => {
                                    if (xhr.response.status === 422) {
                                        this.errors.record(xhr.response.data.errors);
                                    }

                                    this.$toast.error(xhr.response.data.message, { duration:10000 });
                                })
                        })
                            .catch( error => {
                                if (error.response.status === 404) {
                                    this.$toast.error('Nu a fost găsit niciun utilizator asociat cu această adresă  de email!');
                                }
                            })
                    })
                });

            }
        },
    };
</script>

<style scoped>
	.box {
		display: flex;
		flex-direction: column;
		padding: 0 40px;
	}
	.text-box {
		margin-bottom: 20px;
	}
	form {
		display: flex;
		flex-direction: column;
		align-items: center;
	}
	label {
		margin-bottom: 2px;
		font-size: 14px;
		color: #818181;
	}
	input:not([type="checkbox"]) {
		margin-bottom: 10px;
		width: initial;
		line-height: 30px;
		border-radius: 5px;
		border: 1px solid #e7e1e7;
		padding-left: 10px;
		color: #818181;
	}
	input:focus {
		outline: none !important;
		border: 1px solid #6793ce;
	}
	input::placeholder {
		color: #cac5d4;
	}
	.first-text {
		font-size: 22px;
		font-weight: 600;
		background: -webkit-linear-gradient(#262728, #4e5359);
		background-clip: text;
		-webkit-text-fill-color: transparent;
		text-align: left;
		margin: 30px 0 20px 0;
	}
	.form-field {
		display: flex;
		position: relative;
		flex-direction: column;
		width: 100%;
	}
	.checkbox-field {
		display: flex;
		flex-direction: row;
		margin-right: auto;
		align-items: center;
	}
	.buton-register {
		margin-top: 15px;
	}
	.logo-mic {
		position: absolute;
		bottom: 40px;
		right: 50px;
	}
	.logare {
		text-align: center;
		margin-top: 20px;
	}
	.text-blue {
		color: #4d87f1;
	}
    .logo-mic{
        display: none;
    }
    @media (max-height: 800px) {
        .second-text{
            margin-bottom: 20px;
            margin-top: 0;
        }
        .form-group{
            margin-bottom: 0.5rem;
        }
        .form-group >>> label{
            margin-bottom: 0.2rem;
            font-size: 13px;
        }
        .form-group >>> .custom-checkbox label{
            font-size: 13px;
        }
        .btn-primary{
            font-size: 13px;
            margin-top: 10px;
        }
    }
  @media screen and (max-width: 841px) {
    .text-box p {
      color: white;
    }
    .first-text {
      background: -webkit-linear-gradient(#ffffff, #ffffff);
      background-clip: text;
    }
    >>> .d-block {
      color: white;
    }
    >>> .logo-mic {
      display: none;
    }
  }
</style>
